/**
 * I confini delle regioni per la mappa delle aziende. Il file è quello del gestionale (`public/confini/regioni.json`,
 * fonte unica, preparato da `scripts/installazioni/confini-italia.ts`): Vite lo porta nel pacchetto della console col
 * nome che cambia quando cambia il contenuto, quindi non c'è una copia da tenere allineata e il browser non tiene mai
 * una versione vecchia. Si scarica solo quando qualcuno apre la mappa, una volta per sessione.
 */
import indirizzoRegioni from '../../../../public/confini/regioni.json?url';
import { regioniDaGeoJson, type Regione } from '@shared/mappa/geometria';

let inCorso: Promise<Regione[] | null> | null = null;

/** Le regioni, o null se il file non si legge (la mappa mostra le aziende lo stesso, e lo dice). */
export function caricaRegioni(): Promise<Regione[] | null> {
  if (inCorso) return inCorso;
  inCorso = fetch(indirizzoRegioni)
    .then(async (r) => {
      if (!r.ok) throw new Error(`HTTP ${r.status}`);
      const regioni = regioniDaGeoJson((await r.json()) as { features?: unknown });
      if (regioni.length === 0) throw new Error('nessuna regione nel file');
      return regioni;
    })
    .catch((e: unknown) => {
      console.warn('[mappaAziende] confini delle regioni non disponibili', { errore: e instanceof Error ? e.message : String(e) });
      inCorso = null;
      return null;
    });
  return inCorso;
}
